import { ChatSlash } from "@phosphor-icons/react";
import { FormEvent, useEffect, useState } from "react";
import { Button, Variant } from "../../Buttons";
import { DialogProps } from "../../Dialog";
import { Modal } from "@void-orbit/ui";
import { Form } from "../../Form";

export interface CloseServiceModalProps extends Omit<DialogProps, "children"> {
  onConfirm: ( comment?: string ) => Promise<boolean | void> | boolean | void;
}

export const CloseServiceModal = ({
  open,
  onConfirm,
  onClose = () => {},
}: CloseServiceModalProps ) => {
  const [ comment, setComment ] = useState( "" );

  useEffect(() => {
    if( !open ) setComment( "" );
  }, [ open ]);

  const handleSubmit = async ( event: FormEvent ) => {
    event.preventDefault();

    const closed = await onConfirm( comment );
    if( closed !== false ) onClose();
  };

  return (
    <Modal
      open={ open }
      onClose={ onClose }
      title="Encerrar atendimento"
      closeLabel="Fechar encerramento de atendimento"
      icon={
        <ChatSlash
          weight="duotone"
          size={ 32 }
        />
      }
    >
      <Form onSubmit={ handleSubmit }>
        <div className="inputs-view">
          <div className="input-view">
            <label className="input-label" htmlFor="close-service-comment">Comentário interno</label>
            <textarea
              id="close-service-comment"
              rows={ 4 }
              placeholder="Informe o motivo do encerramento"
              value={ comment }
              onChange={( event ) => setComment( event.target.value )}
            />
          </div>
        </div>

        <div className="actions-view">
          <div className="actions-view-row">
            <Button
              $color="text"
              $variant={ Variant.OUTLINED }
              type="button"
              onClick={ onClose }
            >
              Cancelar
            </Button>

            <Button
              $color="error"
              $variant={ Variant.CONTAINED }
              type="submit"
            >
              Encerrar
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
